import * as React from 'react';
import type { SVGProps } from 'react';
const SvgIllustration = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={73}
    height={67}
    fill="none"
    {...props}
  >
    <g clipPath="url(#Illustration_svg__a)">
      <path
        fill="#F2F5F7"
        d="M1.505 47.1c-1.33-.77-1.33-2.69 0-3.46l34.01-19.69c.62-.36 1.38-.36 2 0l34.01 19.69c1.33.77 1.33 2.69 0 3.46l-34.01 19.69c-.62.36-1.38.36-2 0z"
      />
      <path
        fill="#DDE3EA"
        d="m30.98 7.611-5.94 3.44 19.51 43.36 5.95-3.51c.27-.16.37-.49.24-.77L31.82 7.871a.59.59 0 0 0-.84-.26"
      />
      <path
        fill="#fff"
        d="m44.547 54.403-19.51-43.36-15.83 22.14c-.23.29-.14.71.17.88l35.17 20.33z"
      />
      <path
        fill="url(#Illustration_svg__b)"
        d="M31.278 7.531c.22 0 .44.12.54.34l18.92 42.25c.13.28.03.62-.24.77l-5.45 3.21c-.16.09-.33.14-.51.14s-.35-.04-.5-.13l-34.66-20.05c-.32-.18-.4-.6-.17-.88l15.58-21.79c.17-.23.38-.43.63-.57l5.56-3.22a.6.6 0 0 1 .3-.08m0-1.49c-.19 0-.39.03-.57.08h-.13l-.35.2-5.56 3.22c-.43.25-.8.59-1.1.99l-15.56 21.76c-.36.47-.5 1.08-.38 1.66.12.6.49 1.12 1.02 1.42l34.65 20.04a2.48 2.48 0 0 0 2.52-.01l5.45-3.21c.94-.54 1.3-1.7.84-2.7l-18.92-42.22c-.36-.76-1.1-1.23-1.91-1.23"
      />
      <path
        fill="#BAC2CF"
        d="m23.94 22.23 2.43 1.41c.18.11.3.3.3.51v8.41c0 .46-.5.75-.9.51l-2.43-1.41c-.19-.11-.3-.3-.3-.51v-8.41c0-.46.5-.75.9-.51m0 11.112 2.43 1.41c.18.11.3.3.3.51v2.55c0 .46-.5.75-.9.52l-2.43-1.41c-.19-.11-.3-.3-.3-.51v-2.55c0-.46.5-.75.9-.51z"
      />
    </g>
    <defs>
      <linearGradient
        id="Illustration_svg__b"
        x1={9.516}
        x2={38.016}
        y1={33.547}
        y2={45.047}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#CAD0DC" />
        <stop offset={1} stopColor="#BAC2CF" />
      </linearGradient>
      <clipPath id="Illustration_svg__a">
        <path fill="#fff" d="M.5 0h72v67H.5z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgIllustration;
